import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import propTypes from 'prop-types';

import { getEditRouteForScriptId } from 'util/routes';
import { protectionApplicationTypes } from 'constants/activities';
import { uiLocations } from 'constants/analytics';
import { exportTypes } from 'constants/values';
import {
  openDeleteModal,
  openDuplicateModal,
  openRenameModal,
  openSetPrimaryModal,
  setExportOptionsIsOpen
} from 'current/uiwidgets/';

import {
  getActiveScriptId,
  getExportOptionsIsOpen,
  scriptOptionsIsOpenForScriptId,
} from 'current/selectors';
import { canManualScript } from 'product-features/selectors';
import { editScript } from 'scripts';
import {
  canMakeDisplayPrimaryScript,
  getActivityTypeForScript,
  getScriptById,
  isDeleteableScript
} from 'scripts/selectors';

// components
import List from 'common/List';
import EditTrigger from 'triggers/EditTrigger';
import SetPrimaryTrigger from 'triggers/SetPrimaryTrigger';
import RenameTrigger from 'triggers/RenameTrigger';
import ExportTrigger from 'triggers/ExportTrigger';
import DeleteTrigger from 'triggers/DeleteTrigger';
import DuplicateTrigger from 'triggers/DuplicateTrigger';

const baseString = 'vra-options-menu-popover';
class OptionsMenuPopoverContainer extends Component {

  render() {

    const {
      canDuplicateScript,
      canDelete,
      canManualScript,
      canSetPrimary,
      ...props
    } = this.props;

    const classString = classNames({
      [`${baseString}`]: true,
      'vra-popover-menu': true
    });

    return (
      <List
        childClassName="vra-popover-menu__item"
        className={classString}
        name="options-menu"
        testId="options-menu-list"
      >
        <EditTrigger
          disabled={!canManualScript}
          uiLocation={uiLocations.MANAGE_OPTIONS_MENU}
          {...props}
        />
        <SetPrimaryTrigger
          disabled={!canSetPrimary || !canManualScript}
          {...props}
        />
        <RenameTrigger disabled={!canManualScript} {...props} />
        <DuplicateTrigger
          disabled={!canDuplicateScript || !canManualScript}
          uiLocation={uiLocations.MANAGE_OPTIONS_MENU}
          {...props}
        />
        {canManualScript && <ExportTrigger
          {...props}
          uiLocation={uiLocations.MANAGE}
        />}
        <DeleteTrigger
          disabled={!canDelete}
          {...props}
        />
      </List>
    );
  }
}

OptionsMenuPopoverContainer.propTypes = {
  canDelete: propTypes.bool.isRequired,
  canDuplicateScript: propTypes.bool.isRequired,
  canManualScript: propTypes.bool.isRequired,
  canSetPrimary: propTypes.bool.isRequired
};

OptionsMenuPopoverContainer = connect(
  (state) => {
    const scriptId = getActiveScriptId(state);
    const script = getScriptById(state, scriptId);
    return {
      canDuplicateScript: getActivityTypeForScript(script) !== protectionApplicationTypes.APPLICATION_MIX,
      canManualScript: canManualScript(state),
      canSetPrimary: canMakeDisplayPrimaryScript(state, script),
      canDelete: isDeleteableScript(state, script),
      exportOptionsIsOpen: getExportOptionsIsOpen(state, exportTypes.SINGLE),
      linkToEditRoute: getEditRouteForScriptId(state, scriptId),
      script: script,
      scriptId: scriptId,
      scriptOptionsIsOpen: scriptOptionsIsOpenForScriptId(state, scriptId),
    };
  },
  (dispatch) => {
    return {
      onClickDeleteTrigger: (scriptId) => dispatch(openDeleteModal(scriptId)),
      onClickDuplicateTrigger: (scriptId) => dispatch(openDuplicateModal({ scriptId })),
      onClickEditTrigger: ({ scriptId, uiLocation }) => dispatch(editScript({ scriptId, uiLocation })),
      onClickExportTrigger: () => {
        dispatch(setExportOptionsIsOpen({ exportType: exportTypes.SINGLE, status: true }));
      },
      onClickRenameTrigger: (scriptId) => dispatch(openRenameModal(scriptId)),
      onClickSetPrimaryTrigger: (scriptId) => dispatch(openSetPrimaryModal(scriptId))
    };
  }
)(OptionsMenuPopoverContainer);
export default OptionsMenuPopoverContainer;
